import React from 'react';

import GetCirrusoft from './index';

import { useContextState, useContextDispatch, ACTIONS } from '@/context';

const GetCirrusoftModalWithContext = () => {
  const { isCirrusoftModalOpened } = useContextState();
  const dispatch = useContextDispatch();

  const handleCloseModal = () => {
    dispatch({ type: ACTIONS.setGetCirrusoftModal, value: false });
  };

  return (
    <GetCirrusoft isOpen={isCirrusoftModalOpened} onClose={handleCloseModal} />
  );
};

export default GetCirrusoftModalWithContext;
